export const PDS_USER_ID = 'pdsUserId'
export const PDS_USER_EMAIL = 'pdsUserEmail'
export const PDS_USER_AUTH = 'pdsUserAuth'

export const getBrowserUserId = (): number | undefined => {
  const idString: string | null = localStorage.getItem(PDS_USER_ID)
  return idString ? parseInt(idString, 10) : undefined
}
export const getBrowserUserAuth = () =>
  localStorage.getItem(PDS_USER_AUTH) || undefined

export const getBrowserUser = () => {
  const id = getBrowserUserId()
  const authToken = getBrowserUserAuth()
  return { id, authToken }
}

export const persistUserBrowser = (id?: number, authToken?: string) => {
  if (id && authToken) {
    localStorage.setItem(PDS_USER_ID, id.toString())
    localStorage.setItem(PDS_USER_AUTH, authToken)
  }
}

export const removeUserBrowser = () => {
  localStorage.removeItem(PDS_USER_ID)
  localStorage.removeItem(PDS_USER_AUTH)
}
